export enum CourseStatus {
  Fail = 100,
  Pass = 200,
  Suspended = 300,
  BlackListed = 400,
  Barred = 500,
  Expired = 600
}
